import Softwares from 'src/pages/Softwares'

const SoftwaresRoute = () => {
  return <Softwares />
}

export default SoftwaresRoute
